module.exports = __webpack_public_path__ + "206a42cc7fdabb3da3e41521d27ac4cd.jpg";